import { useMemo } from 'react';
import { Navigate, Route, RouteProps, Routes, useResolvedPath } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';

import { AdvisorSettings, EmailCommunications, NoMatch, Profile, ProgramContent, SignInAndSecurity } from '@/pages';
import { NavigationLink } from '@/components';
import { useNavigationConfig } from '@/hooks';

type RouteConfig = {
	main: React.ComponentType;
} & RouteProps;

export const Account = () => {
	const { navigationConfig } = useNavigationConfig();
	const path = useResolvedPath('').pathname;

	const routes: RouteConfig[] = useMemo(
		() => [
			{
				path: '/profile',
				main: Profile,
			},
			{
				path: '/sign-in-and-security',
				main: SignInAndSecurity,
			},
			{
				path: '/program-content',
				main: ProgramContent,
			},
			{
				path: '/email-communications',
				main: EmailCommunications,
			},
			...(navigationConfig?.allowClientManagement && navigationConfig?.allowAccessToInquiries
				? [
						{
							path: '/advisor-settings',
							main: AdvisorSettings,
						},
				  ]
				: []),
			{
				path: '/*',
				main: NoMatch,
			},
		],
		[navigationConfig?.allowAccessToInquiries, navigationConfig?.allowClientManagement]
	);

	return (
		<Container className="py-9">
			<Row>
				<Col lg={3}>
					<h5 className="mb-4 text-uppercase text-gray-800 font-weight-bold">Account Settings</h5>
					<hr className="mb-2" />
					<NavigationLink to={`${path}/profile`}>Profile</NavigationLink>
					<NavigationLink to={`${path}/sign-in-and-security`}>Sign In &amp; Security</NavigationLink>
					<NavigationLink to={`${path}/program-content`}>Program Content</NavigationLink>
					<NavigationLink to={`${path}/email-communications`}>Email Communications</NavigationLink>
					{navigationConfig?.allowClientManagement && navigationConfig?.allowAccessToInquiries && (
						<NavigationLink to={`${path}/advisor-settings`}>Advisor Settings</NavigationLink>
					)}
				</Col>
				<Col lg={9}>
					<Routes>
						<Route index element={<Navigate to="profile" replace />} />

						{routes.map((route, index) => {
							return <Route key={index} path={route.path} element={<route.main />} />;
						})}
					</Routes>
				</Col>
			</Row>
		</Container>
	);
};
